/// <amd-module name="TFS/Token/PatTokenPage/Utils/TokenUtils" />
import { AppToken } from 'Constants/TokenConstants';
import { ScopeGrouping } from 'Generated/Contracts';
import { memoize } from "VSS/Core/Util/Memoize";
import * as React from 'react';
import * as Resources from "TFS/Token/PatTokenPage/Resources";

export default class TokenUtils extends React.Component {

    @memoize
    public static formatTokenScope(tokenScopeList: string, scopeData: {[key: string]: ScopeGrouping}) {
        const splittedScopes = tokenScopeList.split(" ");
        let formattedScope: string[] = [];

        // break case if scope is all scopes
        if(splittedScopes[0] === AppToken) {
            return Resources.FullAccess;
        }

        // map through scopes to render
        splittedScopes.map(scope => {
            for(let group in scopeData) {
                // see if grouping contains scope
                const matchingScopeData = scopeData[group].scopes.filter(scopeInGroup => scopeInGroup.key === scope);
                // adds formatted string to formattedScope
                if(matchingScopeData[0]) {
                    formattedScope.push(`${scopeData[group].name} (${matchingScopeData[0].name})`);;
                }
            }
        })

        return formattedScope.join("; ");
    }
}
